import { Base, Component, Inject, Prop } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../common.type'
import { useMainStore } from '@/store/index'
import style from './style.module.scss'

type Props = {
  /** 边框图片地址 目前没有预设地址,如果后面同一地址重复使用,就将之扩展为预设地址 */
  borderUrl: string
}
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<VirtualBorder>({
  name: 'VirtualBorder'
})
export default class VirtualBorder extends Base<unknown, Props> {
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>
  /** 获得青蓝版样式的边框图片地址 */
  public static getBorderUrlCyanBlue = () => {
    return `/lobby_asset/{layout}-{bg}-common/common/home/${
      useMainStore().isWeb ? 'img_dt_border_sf' : 'img_dt_border_yx'
    }.png`
  }
  /** 取得HK版样式的边框图片地址 */
  public static getBorderUrlHK = () =>
    `/lobby_asset/{layout}-{bg}-{skin}/web/home/img_dt_border18.png`

  /** 取得5021版样式的边框图片地址 */
  public static getBorderUrl5021 = () =>
    `/lobby_asset/{layout}-{bg}-{skin}/web/common/img_dt_border270xz.png`

  /** 取得5060版样式的边框图片地址 */
  public static getBorderUrl5060 = () =>
    `/lobby_asset/25-1-1/web/home/img_dt_border15_h5.png`

  @Prop({ required: true })
  protected borderUrl!: string

  render() {
    const { isAtSwiper, atSwiperDomId } = this.cardProps
    return (
      <my-img
        options={{
          type: 'div',
          lazy: !isAtSwiper,
          immediate: isAtSwiper
        }}
        syncGroupsSrc={isAtSwiper}
        syncGroupsWrapId={atSwiperDomId}
        class={style['virtual-border']}
        src={this.borderUrl}
      ></my-img>
    )
  }
}
